export enum GuidedChangeEventStep {
  DefineChange = "define-change",
  SelectConfiguration = "select-configuration",
  SelectOption = "select-option",
  ReviewConfiguration = "review-configuration",
  ReviewImpact = "review-impact",
  Review = "review",
}

export enum GuidedChangeEventConfigType {
  CheckoutConfig = "checkoutConfig",
  ProductOfferingConfig = "productOfferingConfig",
}
